export default {
  en: {
    error: {
      insert: "Can't add the content. Please try again or contact us",
      unknown: 'An error occured. Please try again or contact us',
    },
  },
};
